import { render, staticRenderFns } from "./LangTemplate.vue?vue&type=template&id=7df2500b"
import script from "./LangTemplate.vue?vue&type=script&lang=js"
export * from "./LangTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports